<template>
  <div class="word">
    <div class="fixed" v-if="!isWx">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
          </div>
          <div style="text-align: center; font-size: 0.35rem">婚姻声明书</div>
          <div style="width: 0.3rem"></div>
        </div>
      </div>
    </div>
    <div class="fixed_pad" v-if="!isWx"></div>
    <div class="title">婚姻情况具结声明书</div>
    <div class="title_one">
      姓名（本人)___性别____ 年龄_____           
    </div>
    <div>
      （身份证号）__________________________
    </div>
    <div class="title_2">
      （以下详细说明本人是否未婚、再婚及曾经婚史等婚姻状况）
      <p>______________________________________________</p>
      <p></p>
      <p></p>
    </div>
    <div>
      本人保证以上情况声明属实，如有不实，愿承担由此而产生的一切法律责任。恐后无凭，立具为证。
    </div>
    <div class="title_3">具结声明人（签名指印）:</div>
    <div class="title_4">__年__月__日</div>
    <div>
      以下由其他当事人（或利害关系人）填写：
    </div>
    <div>
      对于上述的具结声明，我在现场并已知悉内容。
    </div>
    <div>
      其他当事人（或利害关系人）填写：________                      
    </div>
    <div>
      （签名、指印）___________                                                
    </div>
    <div class="title_4">__年__月__日</div>
  </div>
</template>

<script>
import topHeader from "@/components/header";
export default {
  name: "AnnouncePre",
  data() {
    return {
      isWx: sessionStorage.getItem("isWx") || false,
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.word {
  padding: 0.5rem 0.2rem 0 0.2rem;
  & > div {
    font-size: 0.3rem;
  }
  .title {
    text-align: center;
    font-size: 0.4rem;
    font-weight: bold;
    padding: 0.3rem 0;
  }
  .fixed {
    border-bottom: 1px solid #f5f5f5;
    background-color: #fff;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 9;
    .top_normal {
      height: 100%;
      i {
        font-size: 0.32rem;
      }
    }
  }
  .top_header {
    height: 0.7rem;
    padding: 0.2rem 0rem;
    width: 7.04rem;
    margin: 0 auto;
    &.top_sm {
      padding: 0.1rem;
    }

    .to_map {
      font-size: 0.28rem;
      img {
        margin-right: 0.06rem;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
  .fixed_pad {
    padding-top: 1.1rem;
  }
}
.title_one {
  padding: 0.2rem 0 0.2rem 0.2rem;
}

.title_2 {
  padding: 0.3rem 0;
  line-height: 0.8rem;
}
.title_4 {
  padding: 0.3rem 0.2rem 0 0;
  text-align: right;
}
</style>